import { render, staticRenderFns } from "./EditGate.vue?vue&type=template&id=ba405f8e&"
import script from "./EditGate.vue?vue&type=script&lang=js&"
export * from "./EditGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports